import { View, Modal as RNModal, StyleSheet, TouchableOpacity, Text, Platform } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { useColors, ThemeColors } from '../../hooks/useColors';
import { spacing } from '../../theme';

const PHONE_CONTAINER_MAX_WIDTH = 430;

interface ModalProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function Modal({ visible, onClose, children }: ModalProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  
  return (
    <RNModal
      visible={visible}
      animationType="slide"
      transparent={true}
      onRequestClose={onClose}
    >
      <View style={styles.webModalWrapper}>
        <View style={styles.overlay}>
          <View style={styles.content}>
            <View style={styles.header}>
              <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                <Feather name="x" size={24} color={colors.textLight} />
              </TouchableOpacity>
            </View>
            {children}
          </View>
        </View>
      </View>
    </RNModal>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  webModalWrapper: {
    flex: 1,
    ...(Platform.OS === 'web' ? {
      maxWidth: PHONE_CONTAINER_MAX_WIDTH,
      alignSelf: 'center',
      width: '100%',
    } : {}),
  },
  overlay: {
    flex: 1,
    backgroundColor: colors.overlay,
    justifyContent: 'flex-end',
  },
  content: {
    backgroundColor: colors.surface,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    maxHeight: '80%',
  },
  header: {
    padding: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLight,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  closeButton: {
    padding: spacing.xs,
  },
});
